import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RoutesConstantService {
  readonly routes = {
    studentInformationPage: '/student',
    sessionNotesPage: '/sn',
    dashboard: '/dashboard',
    referralsDashboardPage: '/referrals/dashboard',
    referralsEvaluatorViewPage: '/referrals/referrals-evaluations',
    referralsSupervisorViewPage: '/referrals/referrals-evaluations-supervisor',
    newReferralsRequestPage: '/referrals/add-referral',
    viewReferralsRequestPage: '/referrals/view-referral',
    reviewReferralsRequestPage: '/referrals/review-referral',
    referralsParentReferralPage: '/referrals/parent-referral',
    referralsSocialHistoryPackagePage: '/referrals/social-history-package',
    referralsCpsePackagePage: '/referrals/cpse-package',
    referralsManagePwnPage: '/referrals/manage-pwn',
    referralsScheduleShmPage: '/referrals/schedule-shm',
    referralsWithdrawPage: '/referrals/withdrawal',
    referrals: '/referrals/',
    eiChildPage: '/ei/child/',
    eiDashboardPage: '/ei/dashboard',
    iepDocumentPage: '/iep',
    dohmhDashBoardPage: '/dohmh/dohmh-document',
    dohmhAddStudentPage: '/dohmh/dohmh-student',
    dohmhDocumentTransferPage: '/dohmh/dohmh-transfer-doe',
    dohmhViewStudentAndDocsPage: '/dohmh/view-child-documents',
    evaluationsSocialHistoryPackagePage: '/evaluations/shp',
    evaluations: '/evaluations/',
    evaluationsEducational: '/evaluations/educational',
    addiepdocument: '/iep/',
    psychologicalUpdatePage: '/evaluations/psychological-update',
    psychologicalEvaluationPage: '/evaluations/psychological-evaluation',
    assuranceChecklist: '/iep/assurance-checklist/',
    lre: '/iep/lre',
    ineligibilityDocuments: '/iep/ineligibility-documents/',
    waiverofIepMeeting: '/iep/waiverof-iep-meeting',
    declassification: '/iep/declassification/',
    placement: '/placement',
    PersonallyIdentifiableInformation: '/referrals/personally-identifiable/',
    ParentPortalRequestsGrid: '/verification/dashboard',
    AgencyAdminGrid: '/agency-admin/mde',
    centralWaitlist: 'wait-list/MDE',
    agencyWaitlist: 'wait-list/MDE',
    agencyAdminMDE: 'agency-admin/MDE',
    adminAgencyMDE: 'admin/agency-mde',
    addChild: '/ei/add-child',
  };
}
